var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var ShareLinkIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { d: "M3.46583 15.5334C2.56074 14.6283 2 13.3788 2 12C2 9.24365 4.24365 7 6.99995 7L10.0001 7.00071L10.0001 9.00041L6.99995 8.9997C5.34603 9.00041 4.0004 10.346 3.9997 12C4.00111 13.6546 5.34815 14.9988 6.99995 15.0002L10.0001 14.9995L10.0001 16.9992L6.99995 16.9999C5.6218 17.0006 4.37234 16.4385 3.46583 15.5334Z" }),
        React.createElement("path", { d: "M22 12C21.9993 14.7555 19.7556 16.9992 17 16.9999L13.9999 16.9992L13.9999 14.9995L17 15.0002C18.654 14.9995 19.9996 13.6539 20.0003 12C19.9996 10.346 18.6526 9.00182 17 8.9997L13.9999 9.00041V7.00071L17 7C19.7549 7 22 9.24224 22 12Z" }),
        React.createElement("path", { d: "M6.99924 10.9998L6.9992 12.9998L17.0002 13L17.0002 11L6.99924 10.9998Z" })))); };
export var ShareLink = styled(ShareLinkIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=ShareLink.js.map